import * as React from 'react';

import { StaySharpWithoutRouting } from './StaySharp';
import { withRouter, RouteComponentProps } from 'react-router';

export default withRouter((props: RouteComponentProps<any>) => (
    <StaySharpWithoutRouting completion={props.match.params.completion} {...props} />
));
